import React, {useState} from 'react';
import {FormattedMessage} from "react-intl";
import {Popover} from "antd";

interface StatusSwitchProps {
    filtersSelected: any,
    setFiltersSelected: React.Dispatch<React.SetStateAction<any>>,
    setReload: React.Dispatch<React.SetStateAction<boolean>>,
}

const options = {
    all: 'student.all_statuses',
    ongoing: 'student.status.ongoing',
    finished: 'student.status.finished',
};

const StatusSwitch: React.FC<StatusSwitchProps> = ({ filtersSelected, setFiltersSelected, setReload }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectedStatus = options[(filtersSelected.statuses ?? 'all') as keyof typeof options] ?? options.all;

    const selectStatus = (key: string) => {
        setFiltersSelected((filtersSelected:any) => ({ ...filtersSelected, statuses: key === 'all' ? undefined : key}));
        setReload(true);
        setIsOpen(false);
    };

    const PopoverContent = () => {

        return (
            <>
                {
                    Object.entries(options).map((values:any, key) => {
                        if (values[1] != selectedStatus) {
                            return (
                                <div key={values[1]} className='select-item' onClick={() => selectStatus(values[0])}><FormattedMessage id={values[1]} /></div>
                            )
                        }
                    })
                }
            </>
        )
    };

    return <div>
        <Popover
            placement='bottom'
            content={<PopoverContent />}
            overlayClassName='session-switch-popover'
            arrowContent={false}
            open={isOpen}
            trigger='click'
            onOpenChange={() => setIsOpen(!isOpen)}
        >
            <div className='filter-switch'>
                {
                    <span>
                        <FormattedMessage id={selectedStatus} />
                    </span>
                }
                <i className='fal fa-chevron-down' style={{fontSize: 10}} />
            </div>
        </Popover>
    </div>
}

export default StatusSwitch;
